/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Upload_SuccessInputs */



/**
* | output |
* | --- |
* | "Deck uploaded successfully" |
*
* @param {Deck_Upload_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_upload_success = /** @type {((inputs?: Deck_Upload_SuccessInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Upload_SuccessInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deck téléchargé avec succès")
	if (locale === "es") return /** @type {LocalizedString} */ ("Deck cargado exitosamente")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Deck enviado com sucesso")
	if (locale === "it") return /** @type {LocalizedString} */ ("Deck caricato con successo")
	return /** @type {LocalizedString} */ ("Deck uploaded successfully")
});